/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const DrawerWrapper = styled.div`
  margin-right: ${gridSize()}px;
  margin-bottom: ${gridSize()}px;
`;

export const BitbucketLogoWrapper = styled.div`
  padding-left: ${gridSize()}px;
  padding-top: ${gridSize() / 2}px;
`;

export const HeaderNameWrapper = styled.div`
  font-weight: 600;
`;
